<template>
    <div class="Report__field__content">
        <div
            v-if="submission"
            class="Report__field__submission"
        >
            <div class="Report__field__image">
                <img
                    v-if="imageSource"
                    :src="imageSource"
                    alt=""
                >
            </div>

            <v-text-field
                id="submissionText"
                type="text"
                readonly
                :label="field.name"
                v-model="fileName"
                dense
                outlined
            />

            <v-btn
                @click="download"
                v-if="fileId"
                icon
                small
                color="secondary"
                type="button"
            >
                <v-icon small>
                    fas fa-download
                </v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';

export default {
    mixins: [
        ReportFieldBoilerplate
    ],

    mounted() {
        this.getImageData();
    },
};
</script>
